module.exports = __webpack_public_path__ + "static/media/wordSearch-social.49fcc115.png";